import { createNewHandbookApi } from '@/api/handbookApi'
import { createHandbookResponseErrors } from '@/utils/error/responseErrors'

export const MATERIAL_URL = 'warehouse/materials'

const errors = createHandbookResponseErrors('материал', 'материалов')

export const MaterialApi = createNewHandbookApi(MATERIAL_URL, errors)
